module.exports = __webpack_public_path__ + "static/media/1.a29a8d39.png";